import { React, useState, useRef, useEffect } from "react";
import ClientLayout from "../components/layout/ClientLayout";
import BetfairTopNav from "./top-nav-betfair";
import "../../../assets/css/betfair_games.css";
import useSocket from "../../../hooks/useSocket";
import BetfairCasinoBetslipWeb from "./betfair_casino_betslip_web";
import "../../../assets/css/betfair_games.css";
import "../../../assets/css/betfair_games_lo2.css";
import axiosInstance from "../../../utils/axiosInstance";
import { isMobile } from "react-device-detect";
import TPPopUpBetSlip from "../tp-studio/teenpatti_casino_betslip_popup.jsx";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BetfairOmaha = () => {
  const [getBetDelayTime, setGetBetDelayTime] = useState([]);
  const dispatch = useDispatch();
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});

  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [stakeList, setStakeList] = useState({});
  const [showModal, setShowModal] = useState(false);

  const [book1, setBook1] = useState("");
  const [book2, setBook2] = useState("");
  const [book3, setBook3] = useState("");
  const [book4, setBook4] = useState("");
  const [book5, setBook5] = useState("");
  const [book6, setBook6] = useState("");
  const [book7, setBook7] = useState("");
  const [book8, setBook8] = useState("");
  const [book9, setBook9] = useState("");

  const [betList, setBetList] = useState([]);
  const [totalBets, setTotalBets] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [resultData, setResultData] = useState([]);

  let betfairOdds = null;
  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "bfgames",
    type: "omaha"
  });
  //console.log("Socket data:", data);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  let evt_status = "";
  let roundId = "";
  let timeLeft = "";
  let time_percentage = "";
  let round = "";

  let runner1b1 = "";
  let runner1b2 = "";
  let runner1b3 = "";
  let runner1l1 = "";
  let runner1l2 = "";
  let runner1l3 = "";
  let runner2b1 = "";
  let runner2b2 = "";
  let runner2b3 = "";
  let runner2l1 = "";
  let runner2l2 = "";
  let runner2l3 = "";
  let runner3b1 = "";
  let runner3b2 = "";
  let runner3b3 = "";
  let runner3l1 = "";
  let runner3l2 = "";
  let runner3l3 = "";
  let runner4b1 = "";
  let runner4b2 = "";
  let runner4b3 = "";
  let runner4l1 = "";
  let runner4l2 = "";
  let runner4l3 = "";
  let runner5b1 = "";
  let runner5b2 = "";
  let runner5b3 = "";
  let runner5l1 = "";
  let runner5l2 = "";
  let runner5l3 = "";
  let runner6b1 = "";
  let runner6b2 = "";
  let runner6b3 = "";
  let runner6l1 = "";
  let runner6l2 = "";
  let runner6l3 = "";
  let runner7b1 = "";
  let runner7b2 = "";
  let runner7b3 = "";
  let runner7l1 = "";
  let runner7l2 = "";
  let runner7l3 = "";
  let runner8b1 = "";
  let runner8b2 = "";
  let runner8b3 = "";
  let runner8l1 = "";
  let runner8l2 = "";
  let runner8l3 = "";
  let runner9b1 = "";
  let runner9b2 = "";
  let runner9b3 = "";
  let runner9l1 = "";
  let runner9l2 = "";
  let runner9l3 = "";

  let runner1b1_matched = "";
  let runner1b2_matched = "";
  let runner1b3_matched = "";
  let runner1l1_matched = "";
  let runner1l2_matched = "";
  let runner1l3_matched = "";
  let runner2b1_matched = "";
  let runner2b2_matched = "";
  let runner2b3_matched = "";
  let runner2l1_matched = "";
  let runner2l2_matched = "";
  let runner2l3_matched = "";
  let runner3b1_matched = "";
  let runner3b2_matched = "";
  let runner3b3_matched = "";
  let runner3l1_matched = "";
  let runner3l2_matched = "";
  let runner3l3_matched = "";
  let runner4b1_matched = "";
  let runner4b2_matched = "";
  let runner4b3_matched = "";
  let runner4l1_matched = "";
  let runner4l2_matched = "";
  let runner4l3_matched = "";
  let runner5b1_matched = "";
  let runner5b2_matched = "";
  let runner5b3_matched = "";
  let runner5l1_matched = "";
  let runner5l2_matched = "";
  let runner5l3_matched = "";
  let runner6b1_matched = "";
  let runner6b2_matched = "";
  let runner6b3_matched = "";
  let runner6l1_matched = "";
  let runner6l2_matched = "";
  let runner6l3_matched = "";
  let runner7b1_matched = "";
  let runner7b2_matched = "";
  let runner7b3_matched = "";
  let runner7l1_matched = "";
  let runner7l2_matched = "";
  let runner7l3_matched = "";
  let runner8b1_matched = "";
  let runner8b2_matched = "";
  let runner8b3_matched = "";
  let runner8l1_matched = "";
  let runner8l2_matched = "";
  let runner8l3_matched = "";
  let runner9b1_matched = "";
  let runner9b2_matched = "";
  let runner9b3_matched = "";
  let runner9l1_matched = "";
  let runner9l2_matched = "";
  let runner9l3_matched = "";

  let rnr1_status = "";
  let rnr2_status = "";
  let rnr3_status = "";
  let rnr4_status = "";
  let rnr5_status = "";
  let rnr6_status = "";
  let rnr7_status = "";
  let rnr8_status = "";
  let rnr9_status = "";

  let suspend1 = "";
  let suspend2 = "";
  let suspend3 = "";
  let suspend4 = "";
  let suspend5 = "";
  let suspend6 = "";
  let suspend7 = "";
  let suspend8 = "";
  let suspend9 = "";

  let cards_desc = "";
  let cardsDesc = "";

  let rnr1_desc = "";
  let rnr2_desc = "";
  let rnr3_desc = "";
  let rnr4_desc = "";

  let cardsDesc1 = "";
  let cardsDesc2 = "";
  let cardsDesc3 = "";
  let cardsDesc4 = "";
  let max = -219.99078369140625;
  if (data != null && data.data !== null && data.data !== undefined) {
    betfairOdds = data.data;
    roundId = betfairOdds.roundId;
    evt_status = betfairOdds.evt_status;
    timeLeft = betfairOdds.timeLeft;
    time_percentage = betfairOdds.time_percentage;
    round = betfairOdds.round;

    runner1b1 = betfairOdds.runner1b1;
    runner1b2 = betfairOdds.runner1b2;
    runner1b3 = betfairOdds.runner1b3;
    runner1l1 = betfairOdds.runner1l1;
    runner1l2 = betfairOdds.runner1l2;
    runner1l3 = betfairOdds.runner1l3;
    runner2b1 = betfairOdds.runner2b1;
    runner2b2 = betfairOdds.runner2b2;
    runner2b3 = betfairOdds.runner2b3;
    runner2l1 = betfairOdds.runner2l1;
    runner2l2 = betfairOdds.runner2l2;
    runner2l3 = betfairOdds.runner2l3;
    runner3b1 = betfairOdds.runner3b1;
    runner3b2 = betfairOdds.runner3b2;
    runner3b3 = betfairOdds.runner3b3;
    runner3l1 = betfairOdds.runner3l1;
    runner3l2 = betfairOdds.runner3l2;
    runner3l3 = betfairOdds.runner3l3;
    runner4b1 = betfairOdds.runner4b1;
    runner4b2 = betfairOdds.runner4b2;
    runner4b3 = betfairOdds.runner4b3;
    runner4l1 = betfairOdds.runner4l1;
    runner4l2 = betfairOdds.runner4l2;
    runner4l3 = betfairOdds.runner4l3;
    runner5b1 = betfairOdds.runner5b1;
    runner5b2 = betfairOdds.runner5b2;
    runner5b3 = betfairOdds.runner5b3;
    runner5l1 = betfairOdds.runner5l1;
    runner5l2 = betfairOdds.runner5l2;
    runner5l3 = betfairOdds.runner5l3;
    runner6b1 = betfairOdds.runner6b1;
    runner6b2 = betfairOdds.runner6b2;
    runner6b3 = betfairOdds.runner6b3;
    runner6l1 = betfairOdds.runner6l1;
    runner6l2 = betfairOdds.runner6l2;
    runner6l3 = betfairOdds.runner6l3;
    runner7b1 = betfairOdds.runner7b1;
    runner7b2 = betfairOdds.runner7b2;
    runner7b3 = betfairOdds.runner7b3;
    runner7l1 = betfairOdds.runner7l1;
    runner7l2 = betfairOdds.runner7l2;
    runner7l3 = betfairOdds.runner7l3;
    runner8b1 = betfairOdds.runner8b1;
    runner8b2 = betfairOdds.runner8b2;
    runner8b3 = betfairOdds.runner8b3;
    runner8l1 = betfairOdds.runner8l1;
    runner8l2 = betfairOdds.runner8l2;
    runner8l3 = betfairOdds.runner8l3;
    runner9b1 = betfairOdds.runner9b1;
    runner9b2 = betfairOdds.runner9b2;
    runner9b3 = betfairOdds.runner9b3;
    runner9l1 = betfairOdds.runner9l1;
    runner9l2 = betfairOdds.runner9l2;
    runner9l3 = betfairOdds.runner9l3;

    runner1b1_matched = formatTruncate(betfairOdds?.runner1b1_matched);
    runner1b2_matched = formatTruncate(betfairOdds?.runner1b2_matched);
    runner1b3_matched = formatTruncate(betfairOdds?.runner1b3_matched);
    runner1l1_matched = formatTruncate(betfairOdds?.runner1l1_matched);
    runner1l2_matched = formatTruncate(betfairOdds?.runner1l2_matched);
    runner1l3_matched = formatTruncate(betfairOdds?.runner1l3_matched);
    runner2b1_matched = formatTruncate(betfairOdds?.runner2b1_matched);
    runner2b2_matched = formatTruncate(betfairOdds?.runner2b2_matched);
    runner2b3_matched = formatTruncate(betfairOdds?.runner2b3_matched);
    runner2l1_matched = formatTruncate(betfairOdds?.runner2l1_matched);
    runner2l2_matched = formatTruncate(betfairOdds?.runner2l2_matched);
    runner2l3_matched = formatTruncate(betfairOdds?.runner2l3_matched);
    runner3b1_matched = formatTruncate(betfairOdds?.runner3b1_matched);
    runner3b2_matched = formatTruncate(betfairOdds?.runner3b2_matched);
    runner3b3_matched = formatTruncate(betfairOdds?.runner3b3_matched);
    runner3l1_matched = formatTruncate(betfairOdds?.runner3l1_matched);
    runner3l2_matched = formatTruncate(betfairOdds?.runner3l2_matched);
    runner3l3_matched = formatTruncate(betfairOdds?.runner3l3_matched);
    runner4b1_matched = formatTruncate(betfairOdds?.runner4b1_matched);
    runner4b2_matched = formatTruncate(betfairOdds?.runner4b2_matched);
    runner4b3_matched = formatTruncate(betfairOdds?.runner4b3_matched);
    runner4l1_matched = formatTruncate(betfairOdds?.runner4l1_matched);
    runner4l2_matched = formatTruncate(betfairOdds?.runner4l2_matched);
    runner4l3_matched = formatTruncate(betfairOdds?.runner4l3_matched);
    runner5b1_matched = formatTruncate(betfairOdds?.runner5b1_matched);
    runner5b2_matched = formatTruncate(betfairOdds?.runner5b2_matched);
    runner5b3_matched = formatTruncate(betfairOdds?.runner5b3_matched);
    runner5l1_matched = formatTruncate(betfairOdds?.runner5l1_matched);
    runner5l2_matched = formatTruncate(betfairOdds?.runner5l2_matched);
    runner5l3_matched = formatTruncate(betfairOdds?.runner5l3_matched);
    runner6b1_matched = formatTruncate(betfairOdds?.runner6b1_matched);
    runner6b2_matched = formatTruncate(betfairOdds?.runner6b2_matched);
    runner6b3_matched = formatTruncate(betfairOdds?.runner6b3_matched);
    runner6l1_matched = formatTruncate(betfairOdds?.runner6l1_matched);
    runner6l2_matched = formatTruncate(betfairOdds?.runner6l2_matched);
    runner6l3_matched = formatTruncate(betfairOdds?.runner6l3_matched);
    runner7b1_matched = formatTruncate(betfairOdds?.runner7b1_matched);
    runner7b2_matched = formatTruncate(betfairOdds?.runner7b2_matched);
    runner7b3_matched = formatTruncate(betfairOdds?.runner7b3_matched);
    runner7l1_matched = formatTruncate(betfairOdds?.runner7l1_matched);
    runner7l2_matched = formatTruncate(betfairOdds?.runner7l2_matched);
    runner7l3_matched = formatTruncate(betfairOdds?.runner7l3_matched);
    runner8b1_matched = formatTruncate(betfairOdds?.runner8b1_matched);
    runner8b2_matched = formatTruncate(betfairOdds?.runner8b2_matched);
    runner8b3_matched = formatTruncate(betfairOdds?.runner8b3_matched);
    runner8l1_matched = formatTruncate(betfairOdds?.runner8l1_matched);
    runner8l2_matched = formatTruncate(betfairOdds?.runner8l2_matched);
    runner8l3_matched = formatTruncate(betfairOdds?.runner8l3_matched);
    runner9b1_matched = formatTruncate(betfairOdds?.runner9b1_matched);
    runner9b2_matched = formatTruncate(betfairOdds?.runner9b2_matched);
    runner9b3_matched = formatTruncate(betfairOdds?.runner9b3_matched);
    runner9l1_matched = formatTruncate(betfairOdds?.runner9l1_matched);
    runner9l2_matched = formatTruncate(betfairOdds?.runner9l2_matched);
    runner9l3_matched = formatTruncate(betfairOdds?.runner9l3_matched);

    rnr1_status = betfairOdds.rnr1_status;
    rnr2_status = betfairOdds.rnr2_status;
    rnr3_status = betfairOdds.rnr3_status;
    rnr4_status = betfairOdds.rnr4_status;
    rnr5_status = betfairOdds.rnr5_status;
    rnr6_status = betfairOdds.rnr6_status;
    rnr7_status = betfairOdds.rnr7_status;
    rnr8_status = betfairOdds.rnr8_status;
    rnr9_status = betfairOdds.rnr9_status;

    suspend1 = betfairOdds.suspend1;
    suspend2 = betfairOdds.suspend2;
    suspend3 = betfairOdds.suspend3;
    suspend4 = betfairOdds.suspend4;
    suspend5 = betfairOdds.suspend5;
    suspend6 = betfairOdds.suspend6;
    suspend7 = betfairOdds.suspend7;
    suspend8 = betfairOdds.suspend8;
    suspend9 = betfairOdds.suspend9;

    if (evt_status == "SUSPENDED_GAME_ROUND_OVER") {
      if (rnr1_status != "IN_PLAY") {
        rnr1_status = rnr1_status;
      } else {
        rnr1_status = "ROUND OVER !";
      }

      if (rnr2_status != "IN_PLAY") {
        rnr2_status = rnr2_status;
      } else {
        rnr2_status = "ROUND OVER !";
      }

      if (rnr3_status != "IN_PLAY") {
        rnr3_status = rnr3_status;
      } else {
        rnr3_status = "ROUND OVER !";
      }

      if (rnr4_status != "IN_PLAY") {
        rnr4_status = rnr4_status;
      } else {
        rnr4_status = "ROUND OVER !";
      }

      if (rnr5_status != "IN_PLAY") {
        rnr5_status = rnr5_status;
      } else {
        rnr5_status = "ROUND OVER !";
      }

      if (rnr6_status != "IN_PLAY") {
        rnr6_status = rnr6_status;
      } else {
        rnr6_status = "ROUND OVER !";
      }

      if (rnr7_status != "IN_PLAY") {
        rnr7_status = rnr7_status;
      } else {
        rnr7_status = "ROUND OVER !";
      }

      if (rnr8_status != "IN_PLAY") {
        rnr8_status = rnr8_status;
      } else {
        rnr8_status = "ROUND OVER !";
      }

      if (rnr9_status != "IN_PLAY") {
        rnr9_status = rnr9_status;
      } else {
        rnr9_status = "ROUND OVER !";
      }
    }

    ///
    cards_desc = betfairOdds.cards_desc;
    cardsDesc = cards_desc.split(",");

    rnr1_desc = betfairOdds.rnr1_desc;
    cardsDesc1 = rnr1_desc.split(",");
    rnr2_desc = betfairOdds.rnr2_desc;
    cardsDesc2 = rnr2_desc.split(",");
    rnr3_desc = betfairOdds.rnr3_desc;
    cardsDesc3 = rnr3_desc.split(",");
    rnr4_desc = betfairOdds.rnr4_desc;
    cardsDesc4 = rnr4_desc.split(",");
  }
  const getCardImage = (cardValue) => {
    if (cardValue === "NOT AVAILABLE") {
      return `/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg`;
    }

    if (["28", "33", "39", "40"].includes(cardValue)) {
      return `/assets/images/bpstudio/cards/card_simple_${cardValue}.png`;
    }

    return `/assets/images/bpstudio/cards/card_simple_${cardValue}.svg`;
  };

  /// place bet ///

  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    market_type
  ) => {
    if (price <= 0) {
      return;
    }
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "betfair_omaha"
    };
    placeBetObject.catmid = roundId;
    placeBetObject.round = round;
    //console.log(placeBetObject);
    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.selectRnr = selectRnr;
    placeBetObject.marketVal = market_type;
    placeBetObject.game_type = 9;

    setPlaceBetObject(placeBetObject);
    console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);

      setStakeList({
        stake1: data.response.stake1,
        stake2: data.response.stake2,
        stake3: data.response.stake3,
        stake4: data.response.stake4,
        stake5: data.response.stake5,
        stake6: data.response.stake6,
        stake7: data.response.stake7,
        stake8: data.response.stake8
      });
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const getDelayTimes = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/event-limits");
      setGetBetDelayTime(data);
    } catch (error) {
      console.error("Failed to load getDelayTimes data:", error);
    }
  };

  const delayTime = (game_type) => {
    let defaultTime = 8;
    if (getBetDelayTime) {
      for (let i = 0; i < getBetDelayTime.response?.length; i++) {
        let obj = getBetDelayTime.response[i];
        if (obj.game_type == game_type) {
          defaultTime = obj.value;
          break;
        }
      }
    }

    return defaultTime;
  };

  const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

  useEffect(() => {
    fetchProfile();
    getDelayTimes();
  }, []);
  /// place bet ///

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const closeBetSlip = () => {
    setShowBetSlip(false);
  };
  const isProcessing = useRef(false);
  const [loading, setLoading] = useState(false);

  const placeBet = async (amount, profit) => {
    if (isProcessing.current) return;

    isProcessing.current = true;
    setLoading(true);

    placeBetObject.amount = amount;
    placeBetObject.profit = profit;
    console.log(placeBetObject);
    let delay = delayTime(7);

    try {
      await sleep(delay * 1000);
      const response = await axiosInstance.post(
        "/betfair-omaha",
        placeBetObject
      );
      console.log(response);
      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setShowBetSlipPopup(false);
        setBetErrorMessage(messageObj);
        //toast.success(response.data.message);
        //getBook(placeBetObject.catmid);
        fetchUserData(); //balance update on top
        getBook();
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
          //toast.error(errorMessage);
        }
      }
    } finally {
      isProcessing.current = false;
      setLoading(false);
    }
  };

  const fetchUserData = async () => {
    //console.log("Fetching events...");
    try {
      const response = await axiosInstance.get("/user");
      //console.log("user-response->",response);
      if (response.data !== "") {
        await dispatch(setUserData(response.data));
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const getBook = async () => {
    let bookObject = {};
    bookObject.roundId = roundId;
    bookObject.game_type = "betfair-omaha";

    const response = await axiosInstance.post("/betfair-book", bookObject);
    ///
    let userbook = response.data.userbook;
    let userbook2 = response.data.userbook2;
    let bet_list = response.data.bets_list;
    if (userbook && userbook.length > 0) {
      let book1Val = userbook[0].rnr1s;
      let book2Val = userbook[0].rnr2s;
      let book3Val = userbook[0].rnr3s;
      let book4Val = userbook[0].rnr4s;

      setBook1(book1Val);
      setBook2(book2Val);
      setBook3(book3Val);
      setBook4(book4Val);
    } else {
      setBook1("");
      setBook2("");
      setBook3("");
      setBook4("");
    }

    if (userbook2.length > 0) {
      let book5Val = userbook2[0].rnr1s;
      let book6Val = userbook2[0].rnr2s;
      let book7Val = userbook2[0].rnr3s;
      let book8Val = userbook2[0].rnr4s;
      let book9Val = userbook2[0].rnr5s;

      setBook5(book5Val);
      setBook6(book6Val);
      setBook7(book7Val);
      setBook8(book8Val);
      setBook9(book9Val);
    } else {
      setBook5("");
      setBook6("");
      setBook7("");
      setBook8("");
      setBook9("");
    }

    if (bet_list.length > 0) {
      setTotalBets(bet_list.length);
      setBetList(bet_list);
    } else {
      setBetList([]);
    }

    ///
    return response;
  };

  useEffect(() => {
    getBook();
  }, [roundId]);

  useEffect(() => {
    if (data?.user) {
      dispatch(setUserData(data.user));
    }
  }, [data, dispatch]);

  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "betfair-omaha";

    const response = await axiosInstance.post("/betfair-results", resultObj);

    setResultData(response.data.results_list);
    console.log("response->", resultData);
    setShowResult(true);
  };

  const hideResultDetail = async () => {
    setShowResult(false);
  };

  ///
  const tableStyle = { width: "100%", borderCollapse: "collapse" };
  const rowFlexStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    background: "transparent"
  };
  const tdResultsStyle = {
    padding: 1,
    minWidth: 180,
    boxSizing: "border-box",
    height: "auto",
    minHeight: "115px"
  };
  const handTdStyle = {
    padding: 1,
    minWidth: 0,
    flex: "1 1 0",
    boxSizing: "border-box",
    height: "115px"
  };
  const playerCardsStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowWrap: "break-word"
  };
  const playerNameStyle = {
    fontWeight: "bold",
    textAlign: "center",
    width: "100%"
  };
  const cardImagesStyle = {
    display: "flex",
    justifyContent: "center",
    gap: 3,
    flexWrap: "wrap",
    width: "100%"
  };
  const cardImgStyle = {
    width: 47,
    height: 70,
    objectFit: "cover",
    borderRadius: 5
  };
  const handCardImagesStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 2,
    flexWrap: "nowrap",
    width: "100%",
    minWidth: 0,
    overflow: "hidden"
  };
  const cardHandImgStyle = {
    width: 45,
    height: 65,
    objectFit: "contain",
    borderRadius: 5,
    flexShrink: 0
  };
  const playerStatusStyle = {
    color: "#000",
    marginTop: 5,
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    width: "100%"
  };
  ///
  const closeButton = () => {
    setShowModal(false);
  };

  const [isPageLoad, setIsPageLoad] = useState(false);
  useEffect(() => {
    if (data !== null && data !== undefined) {
      setIsPageLoad(true);
    }
  }, [data]);

  const formatResultDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${month}/${day}, ${String(hours).padStart(
      2,
      "0"
    )}:${minutes} ${ampm}`;
  };

  return (
    <ClientLayout showLoader={false}>
      <style>
        {`
          .ExMainCardbundle .runner-position {
            bottom: 0px;
         }
          .ExMainCardbundle .runner-name {
              padding-top: 1px;
          }
          .TdResults {
            padding: 0;
            vertical-align: top;
            flex: 1 1 auto;
            box-sizing: border-box;
            max-width: calc(33.33% - 20px);
            min-width: 120px;
            background: linear-gradient(#535353, #0f0f0f);
            border-radius: 10px;
            margin: 1px;
        }
        .bgwinner {
            border-radius: 10px;
            background-color: #cf8d2e !important;
        }
        .bgLoser {
            border-radius: 10px;
            background-color: #cf3f3f !important;
        }
        .TdResultsWin {
            background: #008000 !important;
        }
        .player-card.stood, .andarbahar-player-card {
          margin-left:auto;
          margin-right:auto;
          min-height:auto;
        }
        .ExMainCardbundle .blackjack .player {
          margin:2px;
        }
          .modal-content-style {
          max-width: 1000px !important;
          width: 100% !important;
          max-height: 95vh !important;
        }
          @media (max-width: 576px) {
            .players-table {
              width: 100% !important;
              margin: 0 !important;
              padding: 0 !important;
            }
            .players-table table {
              width: 100% !important;
              border-collapse: collapse !important;
              border-spacing: 0 !important;
              table-layout: fixed !important;
            }
            .players-table tbody tr:first-child {
              display: flex !important;
              width: 100% !important;
              flex-wrap: nowrap !important;
              margin: 0 !important;
              padding: 0 !important;
            }
            .players-table tbody tr:first-child > td {
              flex: 0 0 100% !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
              margin: 0 !important;
              padding: 0 !important;
              box-sizing: border-box !important;
            }
            .players-table tbody tr:nth-child(2) {
              display: flex !important;
              flex-wrap: wrap !important;
              width: 100% !important;
              margin: 0 !important;
              padding: 0 !important;
              justify-content: flex-start !important;
              align-items: stretch !important;
            }
            .players-table tbody tr:nth-child(2) > td.TdResults {
              flex: 0 0 50% !important;
              width: 50% !important;
              max-width: 50% !important;
              min-width: 0 !important;
              margin: 0 !important;
              padding: 0 !important;
              box-sizing: border-box !important;
            }
            .players-table tbody tr:nth-child(2) .player-cards {
              width: 100% !important;
              margin: 0 !important;
              padding: 0 !important;
              box-sizing: border-box !important;
            }
            .players-table tbody tr:nth-child(2) .player-cards .card-images {
              display: flex !important;
              justify-content: center !important;
              align-items: center !important;
              flex-wrap: nowrap !important;
              gap: 0 !important;
              column-gap: 0 !important;
              row-gap: 0 !important;
              width: 100% !important;
              min-width: 0 !important;
              margin: 0 !important;
              padding: 0 !important;
              box-sizing: border-box !important;
            }
            .players-table tbody tr:nth-child(2) .player-cards .card-images img {
              width: 45px !important;
              height: 65px !important;
              flex: 0 0 45px !important;
              flex-shrink: 0 !important;
              margin: 0 !important;
              padding: 0 !important;
              display: block !important;
              box-sizing: border-box !important;
            }
            .players-table tbody tr:nth-child(2) .player-name {
              width: 100% !important;
              margin: 0 !important;
              padding: 0 !important;
              text-align: center !important;
              box-sizing: border-box !important;
            }
            .TdResults{
              width:100%;
              margin:0;
              min-width:unset !important;
            }
          }
        `}
      </style>
      <div
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          background: "#ffffff"
        }}
      >
        <div className="ExMainCardbundle" style={{ marginBottom: "8px" }}>
          <div
            className="card-header"
            style={{
              background: "#ffffff",
              paddingBottom: "3px",
              paddingTop: "3px"
            }}
          >
            <BetfairTopNav></BetfairTopNav>
          </div>

          {!isPageLoad && (
            <div
              style={{
                zIndex: "1000",
                background: "#fff",
                width: "100%",
                height: "20%",
                opacity: 1,
                textAlign: "center"
              }}
            >
              <div>
                <img src="../assets/images/loadinggif.gif" alt="Loader" />
              </div>
            </div>
          )}

          <div
            className="card-body mainexcard"
            style={{ display: isPageLoad ? "block" : "none" }}
          >
            <div id="ExgamesDiv" className="row">
              <div className="col-lg-8 Exgamesbg">
                <div>
                  <div
                    className="container text-center"
                    style={{
                      background: "#292929",
                      width: isMobile ? "95%" : "100%",
                      padding: "3px"
                    }}
                  >
                    <center className="row">
                      <div className="col-md-4 ExRounds">
                        <div className="round-counter-simple">
                          <div className="round-counter-text">
                            <span className="i18n">Round</span>
                          </div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 1 ? "active" : ""
                            }`}
                            id="roundCounter1"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 2 ? "active" : ""
                            }`}
                            id="roundCounter2"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 3 ? "active" : ""
                            }`}
                            id="roundCounter3"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 4 ? "active" : ""
                            }`}
                            id="roundCounter4"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 5 ? "active" : ""
                            }`}
                            id="roundCounter5"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 6 ? "active" : ""
                            }`}
                            id="roundCounter6"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 7 ? "active" : ""
                            }`}
                            id="roundCounter7"
                          ></div>
                        </div>
                      </div>
                      <div className="col-4 col-md-4">
                        <div id="demoTimer" className="col">
                          <div className="base-timer casino-timer">
                            <svg
                              className="progressBar"
                              x="0px"
                              y="0px"
                              viewBox="0 0 80 80"
                            >
                              <path
                                className="track"
                                d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                              />
                              <path
                                className="fill fill_green"
                                d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                                style={{
                                  strokeDashoffset: ((30 - timeLeft) / 30) * max
                                }}
                              />
                              <text
                                className="value"
                                x="50%"
                                y="55%"
                                style={{
                                  fontSize: "30px",
                                  fontWeight: "bold"
                                }}
                              >
                                {timeLeft}
                              </text>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="col-8  col-md-4 inline-block Gameidcol">
                        Game ID:<span id="round-id">{roundId}</span>
                        <div
                          role="group"
                          aria-label="Second group"
                          className="btn-group btn-group-sm mr-2"
                        >
                          <button
                            type="button"
                            id="Alltab"
                            className={`tablink 
                                                btn 
                                                btn-primary 
                                                 ${
                                                   showResult ? "" : "bbactive"
                                                 }`}
                            onClick={() => hideResultDetail()}
                          >
                            Game
                          </button>
                          <button
                            type="button"
                            id="RESULTStab"
                            className={`tablink 
                                                btn 
                                                btn-primary 
                                                ${
                                                  showResult ? "bbactive" : ""
                                                }`}
                            onClick={() => showResultDetail()}
                          >
                            Results
                          </button>
                          <button
                            type="button"
                            className="tablink btn btn-primary "
                            data-toggle="modal"
                            data-target="#rulesPopup"
                            style={{ display: "inline-block" }}
                            onClick={() => setShowModal(true)}
                          >
                            Rules
                          </button>
                          {showModal && (
                            <div
                              class="modal fade show"
                              id="rulesPopup"
                              tabindex="-1"
                              role="dialog"
                              data-keyboard="false"
                              data-backdrop="static"
                              style={{ display: "block", paddingLeft: "0px" }}
                            >
                              <div
                                class="modal-dialog modal-lg"
                                role="document"
                              >
                                <div
                                  class="modal-content modal-content-style"
                                  style={{
                                    backgroundColor: "#3C444B",
                                    color: "#AAAFB5",
                                    borderRadius: "6px"
                                  }}
                                >
                                  <div
                                    class="modal-header"
                                    style={{
                                      borderBottom: "0px",
                                      padding: "5px",
                                      background: "#e0e0e0"
                                    }}
                                  >
                                    <div
                                      class="modal-title"
                                      id="exampleModalLabel"
                                      style={{
                                        fontSize: "20px",
                                        color: "rgba(0,0,0,.87)",
                                        margin: "5px 0px 0px 10px"
                                      }}
                                    >
                                      <b>Market Rules</b>
                                    </div>
                                    <button
                                      type="button"
                                      class="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                      style={{
                                        color: "white",
                                        margin: "-0.5rem -0.7rem -1rem auto"
                                      }}
                                    >
                                      <span
                                        aria-hidden="true"
                                        style={{
                                          color: "#000",
                                          opacity: "0.8"
                                        }}
                                        onClick={closeButton}
                                      >
                                        ×
                                      </span>
                                    </button>
                                  </div>
                                  <div
                                    class="modal-body"
                                    style={{
                                      marginTop: "0px",
                                      background: "#fff"
                                    }}
                                  >
                                    <div
                                      style={{
                                        background: "#fff",
                                        padding: "10px",
                                        borderRadius: "10px"
                                      }}
                                    >
                                      <div class="row">
                                        <div
                                          class="col-lg-12"
                                          style={{ color: "rgba(0,0,0,.87)" }}
                                        >
                                          <div
                                            id="market-rules-text"
                                            class="modal-body"
                                          >
                                            <div
                                              class="text-block-renderer-component"
                                              style={{ textAlign: "left" }}
                                            >
                                              <div class="section">
                                                <h2 class="section-title">
                                                  <span class="i18n">
                                                    Win Only Market
                                                  </span>
                                                </h2>
                                                <div class="section-content">
                                                  {/*<p class="paragraph"><span class="i18n bold">Total matched so far: </span>$42</p>*/}
                                                  <p class="paragraph">
                                                    <span class="i18n bold">
                                                      Commission on this market:{" "}
                                                    </span>
                                                    1%
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="section">
                                                <h2 class="section-title">
                                                  <span class="i18n">
                                                    BetPro Exchange Omaha Hi
                                                    Rules
                                                  </span>
                                                </h2>
                                                <div class="section-content">
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      This game is based on the
                                                      poker game commonly known
                                                      as 'Omaha High'.
                                                    </span>
                                                  </p>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Each game begins with 21
                                                      cards being dealt face
                                                      down from one randomly
                                                      shuffled pack. 16 of the
                                                      21 cards are grouped in
                                                      fours to form 4 separate
                                                      hands as displayed on the
                                                      site (these cards grouped
                                                      in fours can be known as
                                                      'hole cards'). The
                                                      remaining 5 cards form a
                                                      pool of community cards.
                                                    </span>
                                                  </p>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      The first round of betting
                                                      occurs whilst all cards
                                                      are face down (The
                                                      "deal"). Players should
                                                      bet on which individual
                                                      hand they think will win
                                                      the game. Bets can be
                                                      placed to back or lay each
                                                      hand.
                                                    </span>
                                                  </p>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Each round of betting
                                                      lasts for a specific
                                                      period of time before
                                                      unmatched bets are
                                                      cancelled and the next
                                                      cards turned face up. The
                                                      length of time is
                                                      indicated by the movement
                                                      of the bar just below the
                                                      community cards. (Please
                                                      note the progress bar is
                                                      an indication only).
                                                    </span>
                                                  </p>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      At the end of the first
                                                      round of betting,
                                                      unmatched bets are
                                                      cancelled and the hands of
                                                      four of cards forming the
                                                      individual hands are
                                                      simultaneously turned face
                                                      up. There is then another
                                                      round of betting, again
                                                      bets can back or lay each
                                                      individual hand within the
                                                      game (Pre Flop).
                                                    </span>
                                                  </p>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      At the end of the second
                                                      round of betting,
                                                      unmatched bets are
                                                      cancelled and the first
                                                      three of the community
                                                      cards (sometimes known as
                                                      the 'flop') are turned
                                                      face up. Another round of
                                                      betting then begins.
                                                    </span>
                                                  </p>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      The end of the third round
                                                      of betting sees unmatched
                                                      bets cancelled before the
                                                      fourth card from the
                                                      community cards is turned
                                                      face up (this card is
                                                      sometimes know as the
                                                      'turn'). Another round of
                                                      betting then commences.
                                                    </span>
                                                  </p>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      The fourth and final round
                                                      of betting finishes with
                                                      unmatched bets cancelled
                                                      before the fifth and final
                                                      of the community cards is
                                                      turned face up (this is
                                                      sometimes known as the
                                                      'river').
                                                    </span>
                                                  </p>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      The result of the game is
                                                      determined by which hand
                                                      is best within the
                                                      predetermined rank system.
                                                      Should two hands be of
                                                      equal standing then dead
                                                      heat rules will apply.
                                                      Each hand must consist of
                                                      two hole cards and three
                                                      community cards.
                                                    </span>
                                                  </p>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      The rank system that
                                                      determines the winning
                                                      hand is as follows with
                                                      the highest first:
                                                    </span>
                                                  </p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Royal Flush
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Ace, King, Queen, Jack,
                                                      Ten of the same suit.
                                                    </span>
                                                  </p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Straight Flush
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Straight with all five
                                                      cards in the same suit.
                                                    </span>
                                                  </p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Four of a Kind
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Four cards of the same
                                                      number or face value
                                                      ('quads').
                                                    </span>
                                                  </p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Full House
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Three cards of one number
                                                      or face value and two
                                                      cards of another number or
                                                      face value. If more than
                                                      one player has a full
                                                      house, the full house with
                                                      the highest ranking three
                                                      of a kind ('trips') wins.
                                                    </span>
                                                  </p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Flush
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Five cards of the same
                                                      suit. If there is more
                                                      than one flush, the hand
                                                      with the highest card(s)
                                                      wins.
                                                    </span>
                                                  </p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Straight
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Five cards in sequence.
                                                      Cards can be in any suit.
                                                      An Ace can be used in the
                                                      highest straight (10, J,
                                                      Q, K, A) and the lowest
                                                      straight (A, 2, 3, 4, 5).
                                                      If there is more than one
                                                      straight, the hand with
                                                      the highest card in the
                                                      straight wins.
                                                    </span>
                                                  </p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Three of a Kind
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Three cards of the same
                                                      number or face value
                                                      ('trips').
                                                    </span>
                                                  </p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Two Pair
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      If two players have two
                                                      pair, the hand with the
                                                      highest pair wins. If they
                                                      have the same high pair,
                                                      whoever has the second
                                                      highest pair wins. If they
                                                      have the same two pair,
                                                      whoever has the highest
                                                      fifth card ('kicker') wins
                                                    </span>
                                                  </p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      One Pair
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Two cards of the same
                                                      number or face value. If
                                                      two players have the same
                                                      pair, the highest outside
                                                      card(s) wins.
                                                    </span>
                                                  </p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      High Card
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      The hand with the highest
                                                      card(s) wins.
                                                    </span>
                                                  </p>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Should two or more hands
                                                      have cards or combinations
                                                      of cards with equal
                                                      standing and value then
                                                      the value of the remaining
                                                      cards in that hand is used
                                                      to determine the winner
                                                      (sometimes known as the
                                                      kicker). Should one or
                                                      more hands still be of
                                                      equal value then dead heat
                                                      rules will apply to the
                                                      winning hands (sometimes
                                                      known as 'splitting the
                                                      pot').
                                                    </span>
                                                  </p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Betting Selections
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      In Exchange Omaha Hi,
                                                      there are two markets
                                                      which are available for
                                                      betting for any given
                                                      Omaha Hi game. The two
                                                      markets each hold
                                                      different types of betting
                                                      selections. The first
                                                      market is known as the
                                                      main market and contains
                                                      the betting selections for
                                                      the Game Outcome, i.e.
                                                      Hand 1, Hand 2, Hand 3 and
                                                      Hand 4. This market is
                                                      known as a ‘Win Only
                                                      Market’ and generally only
                                                      a single selection will
                                                      win (however it is
                                                      possible for a dead heat
                                                      to occur when the winning
                                                      selections will be settled
                                                      according to the dead heat
                                                      rules). The Side bets
                                                      market is also a ‘Win Only
                                                      Market’, however for this
                                                      market each of the
                                                      selections are mutually
                                                      exclusive and therefore
                                                      one of the selections will
                                                      win, and the other
                                                      selections will be settled
                                                      as losers. It’s also
                                                      important to note that the
                                                      main and side bets markets
                                                      are two separate markets
                                                      with commission on each
                                                      charged at according to
                                                      the standard betpro
                                                      Exchange commission
                                                      charging model.
                                                    </span>
                                                  </p>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      The side bets selections
                                                      are as follows:
                                                    </span>
                                                  </p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Winner has a Full House or
                                                      better
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Will the winning hand(s)
                                                      have a Full House or
                                                      better?
                                                    </span>
                                                  </p>
                                                  <p class="paragraph"></p>
                                                  <ol>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Full House then
                                                        this selection wins
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Four-of-a-Kind
                                                        then this selection wins
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Straight Flush
                                                        then this selection wins
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Royal Flush then
                                                        this selection wins
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Flush then this
                                                        selection loses
                                                      </span>
                                                    </li>
                                                  </ol>
                                                  <p></p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Winner has a Flush
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Will the winning hand(s)
                                                      have a Flush?
                                                    </span>
                                                  </p>
                                                  <p class="paragraph"></p>
                                                  <ol>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Flush then this
                                                        selection wins
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Straight Flush
                                                        then this selection
                                                        loses
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Royal Flush then
                                                        this selection loses
                                                      </span>
                                                    </li>
                                                  </ol>
                                                  <p></p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Winner has a Straight
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Will the winning hand(s)
                                                      have a Straight?
                                                    </span>
                                                  </p>
                                                  <p class="paragraph"></p>
                                                  <ol>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Straight then this
                                                        selection wins
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Straight Flush
                                                        then this selection
                                                        loses
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Royal Flush then
                                                        this selection loses
                                                      </span>
                                                    </li>
                                                  </ol>
                                                  <p></p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Winner has a
                                                      Three-of-a-Kind
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Will the winning hand(s)
                                                      have Three-of-a-Kind?
                                                    </span>
                                                  </p>
                                                  <p class="paragraph"></p>
                                                  <ol>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Three-of-a-Kind
                                                        then this selection wins
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Full House then
                                                        this selection loses
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Four-of-a-Kind
                                                        then this selection
                                                        loses
                                                      </span>
                                                    </li>
                                                  </ol>
                                                  <p></p>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      Winner has a Two pair or
                                                      worse
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Will the winning hand(s)
                                                      have Two Pair or less?
                                                    </span>
                                                  </p>
                                                  <p class="paragraph"></p>
                                                  <ol>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has Two Pair then this
                                                        selection wins
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has One Pair then this
                                                        selection wins
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has No Pair, High Card
                                                        then this selections
                                                        wins
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Full House then
                                                        this selection loses
                                                      </span>
                                                    </li>
                                                    <li>
                                                      <span class="i18n">
                                                        If the winning hand(s)
                                                        has a Four-of-a-Kind
                                                        then this selection
                                                        loses
                                                      </span>
                                                    </li>
                                                  </ol>
                                                  <p></p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </center>
                  </div>
                </div>
                <div
                  id="AlltabData"
                  className="tabcontent"
                  style={{ display: showResult ? "none" : "contents" }}
                >
                  <div className="left-content">
                    <div className="cards-layout blackjack">
                      <div>
                        <div className="dealer">
                          <div className="player-item">
                            <span className="name">Dealer</span>
                            <div className="player-card">
                              <div
                                id="BFBCardHandView"
                                className="BFBCardHandViewDealer"
                              >
                                <div id="cards_desc" className="BFBCardFanView">
                                  {cardsDesc &&
                                    cardsDesc.length > 0 &&
                                    cardsDesc.map((card, index) => {
                                      const cardImage = getCardImage(card);
                                      const cardClass = `card${index + 1}in5`;
                                      return (
                                        <div
                                          key={index}
                                          id="BFBCardView"
                                          className={cardClass}
                                        >
                                          <img
                                            id="RSMImageView"
                                            src={cardImage}
                                            alt={`Card ${card}`}
                                            className="RSMImageView"
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="player">
                          <div className="player-item">
                            <span className="name">Hand 1</span>
                            <div
                              className="player-card  stood"
                              style={{
                                padding: "unset",
                                width: "auto",
                                height: "auto"
                              }}
                            >
                              <div
                                id="BFBCardHandView"
                                className="BFBCardHandView"
                              >
                                <div id="rnr1_desc" className="BFBCardFanView">
                                  {cardsDesc1 &&
                                    cardsDesc1.length > 0 &&
                                    cardsDesc1.map((card, index) => {
                                      const cardImage = getCardImage(card);
                                      const cardClass = `card${index + 1}in4`;
                                      return (
                                        <div
                                          key={index}
                                          id="BFBCardView"
                                          className={cardClass}
                                        >
                                          <img
                                            id="RSMImageView"
                                            src={cardImage}
                                            alt={`Card ${card}`}
                                            className="RSMImageView"
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="player">
                          <div className="player-item">
                            <span className="name">Hand 2</span>
                            <div
                              className="player-card  stood"
                              style={{
                                padding: "unset",
                                width: "auto",
                                height: "auto"
                              }}
                            >
                              <div
                                id="BFBCardHandView"
                                className="BFBCardHandView"
                              >
                                <div id="rnr2_desc" className="BFBCardFanView">
                                  {cardsDesc2 &&
                                    cardsDesc2.length > 0 &&
                                    cardsDesc2.map((card, index) => {
                                      const cardImage = getCardImage(card);
                                      const cardClass = `card${index + 1}in4`;
                                      return (
                                        <div
                                          key={index}
                                          id="BFBCardView"
                                          className={cardClass}
                                        >
                                          <img
                                            id="RSMImageView"
                                            src={cardImage}
                                            alt={`Card ${card}`}
                                            className="RSMImageView"
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="player">
                          <div className="player-item">
                            <span className="name">Hand 3</span>
                            <div
                              className="player-card  stood"
                              style={{
                                padding: "unset",
                                width: "auto",
                                height: "auto"
                              }}
                            >
                              <div
                                id="BFBCardHandView"
                                className="BFBCardHandView"
                              >
                                <div id="rnr3_desc" className="BFBCardFanView">
                                  {cardsDesc3 &&
                                    cardsDesc3.length > 0 &&
                                    cardsDesc3.map((card, index) => {
                                      const cardImage = getCardImage(card);
                                      const cardClass = `card${index + 1}in4`;
                                      return (
                                        <div
                                          key={index}
                                          id="BFBCardView"
                                          className={cardClass}
                                        >
                                          <img
                                            id="RSMImageView"
                                            src={cardImage}
                                            alt={`Card ${card}`}
                                            className="RSMImageView"
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="player">
                          <div className="player-item">
                            <span className="name">Hand 4</span>
                            <div
                              className="player-card  stood"
                              style={{
                                padding: "unset",
                                width: "auto",
                                height: "auto"
                              }}
                            >
                              <div
                                id="BFBCardHandView"
                                className="BFBCardHandView"
                              >
                                <div id="rnr4_desc" className="BFBCardFanView">
                                  {cardsDesc4 &&
                                    cardsDesc4.length > 0 &&
                                    cardsDesc4.map((card, index) => {
                                      const cardImage = getCardImage(card);
                                      const cardClass = `card${index + 1}in4`;
                                      return (
                                        <div
                                          key={index}
                                          id="BFBCardView"
                                          className={cardClass}
                                        >
                                          <img
                                            id="RSMImageView"
                                            src={cardImage}
                                            alt={`Card ${card}`}
                                            className="RSMImageView"
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <center>
                      <div
                        className="progress"
                        style={{
                          height: "3px",
                          maxWidth: "50%",
                          marginBottom: "8px"
                        }}
                      >
                        <div
                          id="Exgamesprogress"
                          role="progressbar"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          className="progress-bar bg-danger"
                          style={{ width: "0%" }}
                          sid="roundProgressWidth"
                        ></div>
                      </div>
                    </center>
                    <div className="section-blur">
                      <div className="market-titlebar">
                        <p className="market-name"></p>
                        <div className="market-overarround">
                          <span></span>
                          <strong>Back</strong>
                        </div>
                        <div className="market-overarround market-overarround-lay">
                          <strong>Lay</strong>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b1status">
                          <h3
                            className={`runner-name ${
                              rnr1_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Hand 1
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus1">
                                    {book1 !== "" ? (
                                      Number(book1) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book1)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book1)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>
                          <a
                            className="price-price price-back rnr1_status span1details"
                            id="runner1b3span"
                            data-teamname="Hand 1"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hand 1",
                                "3",
                                runner1b3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner1b3">
                              {runner1b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1b3_matched"
                            >
                              {runner1b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr1_status span1details"
                            id="runner1b2span"
                            data-teamname="Hand 1"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hand 1",
                                "2",
                                runner1b2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner1b2">
                              {runner1b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1b2_matched"
                            >
                              {runner1b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr1_status span1details"
                            id="runner1b1span"
                            data-teamname="Hand 1"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hand 1",
                                "1",
                                runner1b1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner1b1">
                              {runner1b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1b1_matched"
                            >
                              {runner1b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr1_status span1details"
                            id="runner1l1span"
                            data-teamname="Hand 1"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hand 1",
                                "1",
                                runner1l1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner1l1">
                              {runner1l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1l1_matched"
                            >
                              {runner1l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr1_status span1details"
                            id="runner1l2span"
                            data-teamname="Hand 1"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hand 1",
                                "2",
                                runner1l2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner1l2">
                              {runner1l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1l2_matched"
                            >
                              {runner1l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr1_status span1details"
                            id="runner1l3span"
                            data-teamname="Hand 1"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hand 1",
                                "3",
                                runner1l3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner1l3">
                              {runner1l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1l3_matched"
                            >
                              {runner1l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr1_status"
                            style={{
                              display:
                                suspend1 != 0 ||
                                rnr1_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr1_status}
                          </div>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b2status">
                          <h3
                            className={`runner-name ${
                              rnr2_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Hand 2
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus2">
                                    {book2 !== "" ? (
                                      Number(book2) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book2)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book2)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>
                          <a
                            className="price-price price-back rnr2_status span1details"
                            id="runner2b3span"
                            data-teamname="Hand 2"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hand 2",
                                "3",
                                runner2b3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner2b3">
                              {runner2b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2b3_matched"
                            >
                              {runner2b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr2_status span1details"
                            id="runner2b2span"
                            data-teamname="Hand 2"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hand 2",
                                "2",
                                runner2b2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner2b2">
                              {runner2b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2b2_matched"
                            >
                              {runner2b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr2_status span1details"
                            id="runner2b1span"
                            data-teamname="Hand 2"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hand 2",
                                "1",
                                runner2b1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner2b1">
                              {runner2b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2b1_matched"
                            >
                              {runner2b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr2_status span1details"
                            id="runner2l1span"
                            data-teamname="Hand 2"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hand 2",
                                "1",
                                runner2l1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner2l1">
                              {runner2l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2l1_matched"
                            >
                              {runner2l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr2_status span1details"
                            id="runner2l2span"
                            data-teamname="Hand 2"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hand 2",
                                "2",
                                runner2l2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner2l2">
                              {runner2l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2l2_matched"
                            >
                              {runner2l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr2_status span1details"
                            id="runner2l3span"
                            data-teamname="Hand 2"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hand 2",
                                "3",
                                runner2l3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner2l3">
                              {runner2l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2l3_matched"
                            >
                              {runner2l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr2_status"
                            style={{
                              display:
                                suspend2 != 0 ||
                                rnr2_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr2_status}
                          </div>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b3status">
                          <h3
                            className={`runner-name ${
                              rnr3_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Hand 3
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus3">
                                    {book3 !== "" ? (
                                      Number(book3) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book3)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book3)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>
                          <a
                            className="price-price price-back rnr3_status span1details"
                            id="runner3b3span"
                            data-teamname="Hand 3"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hand 3",
                                "3",
                                runner3b3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner3b3">
                              {runner3b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3b3_matched"
                            >
                              {runner3b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr3_status span1details"
                            id="runner3b2span"
                            data-teamname="Hand 3"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hand 3",
                                "2",
                                runner3b2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner3b2">
                              {runner3b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3b2_matched"
                            >
                              {runner3b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr3_status span1details"
                            id="runner3b1span"
                            data-teamname="Hand 3"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hand 3",
                                "1",
                                runner3b1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner3b1">
                              {runner3b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3b1_matched"
                            >
                              {runner3b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr3_status span1details"
                            id="runner3l1span"
                            data-teamname="Hand 3"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hand 3",
                                "1",
                                runner3l1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner3l1">
                              {runner3l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3l1_matched"
                            >
                              {runner3l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr3_status span1details"
                            id="runner3l2span"
                            data-teamname="Hand 3"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hand 3",
                                "2",
                                runner3l2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner3l2">
                              {runner3l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3l2_matched"
                            >
                              {runner3l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr3_status span1details"
                            id="runner3l3span"
                            data-teamname="Hand 3"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hand 3",
                                "3",
                                runner3l3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner3l3">
                              {runner3l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3l3_matched"
                            >
                              {runner3l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr3_status"
                            style={{
                              display:
                                suspend3 != 0 ||
                                rnr3_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr3_status}
                          </div>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b4status">
                          <h3
                            className={`runner-name ${
                              rnr4_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Hand 4
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus4">
                                    {book4 !== "" ? (
                                      Number(book4) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book4)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book4)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>
                          <a
                            className="price-price price-back rnr4_status span1details"
                            id="runner4b3span"
                            data-teamname="Hand 4"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hand 4",
                                "3",
                                runner4b3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner4b3">
                              {runner4b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4b3_matched"
                            >
                              {runner4b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr4_status span1details"
                            id="runner4b2span"
                            data-teamname="Hand 4"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hand 4",
                                "2",
                                runner4b2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner4b2">
                              {runner4b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4b2_matched"
                            >
                              {runner4b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr4_status span1details"
                            id="runner4b1span"
                            data-teamname="Hand 4"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hand 4",
                                "1",
                                runner4b1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner4b1">
                              {runner4b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4b1_matched"
                            >
                              {runner4b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr4_status span1details"
                            id="runner4l1span"
                            data-teamname="Hand 4"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hand 4",
                                "1",
                                runner4l1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner4l1">
                              {runner4l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4l1_matched"
                            >
                              {runner4l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr4_status span1details"
                            id="runner4l2span"
                            data-teamname="Hand 4"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hand 4",
                                "2",
                                runner4l2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner4l2">
                              {runner4l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4l2_matched"
                            >
                              {runner4l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr4_status span1details"
                            id="runner4l3span"
                            data-teamname="Hand 4"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hand 4",
                                "3",
                                runner4l3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner4l3">
                              {runner4l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4l3_matched"
                            >
                              {runner4l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr4_status"
                            style={{
                              display:
                                suspend4 != 0 ||
                                rnr4_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr4_status}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="section-blur">
                      <div class="market-titlebar">
                        <p class="market-name"></p>
                        <div class="market-overarround">
                          <span></span>
                          <strong>Back</strong>
                        </div>
                        <div class="market-overarround market-overarround-lay">
                          <strong>Lay</strong>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b5status">
                          <h3
                            className={`runner-name ${
                              rnr5_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Winner has FH or better
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus5">
                                    {book5 !== "" ? (
                                      Number(book5) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book5)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book5)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>
                          <a
                            className="price-price price-back rnr5_status span1details"
                            id="runner5b3span"
                            data-teamname="Winner has FH or better"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has FH or better",
                                "3",
                                runner5b3,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner5b3">
                              {runner5b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner5b3_matched"
                            >
                              {runner5b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr5_status span1details"
                            id="runner5b2span"
                            data-teamname="Winner has FH or better"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has FH or better",
                                "2",
                                runner5b2,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner5b2">
                              {runner5b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner5b2_matched"
                            >
                              {runner5b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr5_status span1details"
                            id="runner5b1span"
                            data-teamname="Winner has FH or better"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has FH or better",
                                "1",
                                runner5b1,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner5b1">
                              {runner5b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner5b1_matched"
                            >
                              {runner5b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr5_status span1details"
                            id="runner5l1span"
                            data-teamname="Winner has FH or better"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has FH or better",
                                "1",
                                runner5l1,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner5l1">
                              {runner5l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner5l1_matched"
                            >
                              {runner5l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr5_status span1details"
                            id="runner5l2span"
                            data-teamname="Winner has FH or better"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has FH or better",
                                "2",
                                runner5l2,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner5l2">
                              {runner5l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner5l2_matched"
                            >
                              {runner5l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr5_status span1details"
                            id="runner5l3span"
                            data-teamname="Winner has FH or better"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has FH or better",
                                "3",
                                runner5l3,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner5l3">
                              {runner5l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner5l3_matched"
                            >
                              {runner5l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr5_status"
                            style={{
                              display:
                                suspend5 != 0 ||
                                rnr5_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr5_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b6status">
                          <h3
                            className={`runner-name ${
                              rnr6_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Winner has Flush
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus6">
                                    {book6 !== "" ? (
                                      Number(book6) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book6)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book6)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>
                          <a
                            className="price-price price-back rnr6_status span1details"
                            id="runner6b3span"
                            data-teamname="Winner has Flush"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has Flush",
                                "3",
                                runner6b3,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner6b3">
                              {runner6b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner6b3_matched"
                            >
                              {runner6b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr6_status span1details"
                            id="runner6b2span"
                            data-teamname="Winner has Flush"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has Flush",
                                "2",
                                runner6b2,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner6b2">
                              {runner6b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner6b2_matched"
                            >
                              {runner6b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr6_status span1details"
                            id="runner6b1span"
                            data-teamname="Winner has Flush"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has Flush",
                                "1",
                                runner6b1,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner6b1">
                              {runner6b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner6b1_matched"
                            >
                              {runner6b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr6_status span1details"
                            id="runner6l1span"
                            data-teamname="Winner has Flush"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has Flush",
                                "1",
                                runner6l1,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner6l1">
                              {runner6l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner6l1_matched"
                            >
                              {runner6l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr6_status span1details"
                            id="runner6l2span"
                            data-teamname="Winner has Flush"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has Flush",
                                "2",
                                runner6l2,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner6l2">
                              {runner6l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner6l2_matched"
                            >
                              {runner6l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr6_status span1details"
                            id="runner6l3span"
                            data-teamname="Winner has Flush"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has Flush",
                                "3",
                                runner6l3,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner6l3">
                              {runner6l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner6l3_matched"
                            >
                              {runner6l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr6_status"
                            style={{
                              display:
                                suspend6 != 0 ||
                                rnr6_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr6_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b7status">
                          <h3
                            className={`runner-name ${
                              rnr7_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Winner has Straight
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus7">
                                    {book7 !== "" ? (
                                      Number(book7) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book7)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book7)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>
                          <a
                            className="price-price price-back rnr7_status span1details"
                            id="runner7b3span"
                            data-teamname="Winner has Straight"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has Straight",
                                "3",
                                runner7b3,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner7b3">
                              {runner7b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner7b3_matched"
                            >
                              {runner7b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr7_status span1details"
                            id="runner7b2span"
                            data-teamname="Winner has Straight"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has Straight",
                                "2",
                                runner7b2,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner7b2">
                              {runner7b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner7b2_matched"
                            >
                              {runner7b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr7_status span1details"
                            id="runner7b1span"
                            data-teamname="Winner has Straight"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has Straight",
                                "1",
                                runner7b1,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner7b1">
                              {runner7b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner7b1_matched"
                            >
                              {runner7b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr7_status span1details"
                            id="runner7l1span"
                            data-teamname="Winner has Straight"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has Straight",
                                "1",
                                runner7l1,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner7l1">
                              {runner7l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner7l1_matched"
                            >
                              {runner7l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr7_status span1details"
                            id="runner7l2span"
                            data-teamname="Winner has Straight"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has Straight",
                                "2",
                                runner7l2,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner7l2">
                              {runner7l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner7l2_matched"
                            >
                              {runner7l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr7_status span1details"
                            id="runner7l3span"
                            data-teamname="Winner has Straight"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has Straight",
                                "3",
                                runner7l3,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner7l3">
                              {runner7l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner7l3_matched"
                            >
                              {runner7l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr7_status"
                            style={{
                              display:
                                suspend7 != 0 ||
                                rnr7_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr7_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b8status">
                          <h3
                            className={`runner-name ${
                              rnr8_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Winner has Three of a Kind
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus8">
                                    {book8 !== "" ? (
                                      Number(book8) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book8)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book8)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>
                          <a
                            className="price-price price-back rnr8_status span1details"
                            id="runner8b3span"
                            data-teamname="Winner has Three of a Kind"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has Three of a Kind",
                                "3",
                                runner8b3,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner8b3">
                              {runner8b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner8b3_matched"
                            >
                              {runner8b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr8_status span1details"
                            id="runner8b2span"
                            data-teamname="Winner has Three of a Kind"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has Three of a Kind",
                                "2",
                                runner8b2,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner8b2">
                              {runner8b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner8b2_matched"
                            >
                              {runner8b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr8_status span1details"
                            id="runner8b1span"
                            data-teamname="Winner has Three of a Kind"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has Three of a Kind",
                                "1",
                                runner8b1,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner8b1">
                              {runner8b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner8b1_matched"
                            >
                              {runner8b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr8_status span1details"
                            id="runner8l1span"
                            data-teamname="Winner has Three of a Kind"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has Three of a Kind",
                                "1",
                                runner8l1,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner8l1">
                              {runner8l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner8l1_matched"
                            >
                              {runner8l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr8_status span1details"
                            id="runner8l2span"
                            data-teamname="Winner has Three of a Kind"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has Three of a Kind",
                                "2",
                                runner8l2,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner8l2">
                              {runner8l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner8l2_matched"
                            >
                              {runner8l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr8_status span1details"
                            id="runner8l3span"
                            data-teamname="Winner has Three of a Kind"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has Three of a Kind",
                                "3",
                                runner8l3,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner8l3">
                              {runner8l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner8l3_matched"
                            >
                              {runner8l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr8_status"
                            style={{
                              display:
                                suspend8 != 0 ||
                                rnr8_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr8_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b9status">
                          <h3
                            className={`runner-name ${
                              rnr9_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Winner has Two Pair or worse
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus9">
                                    {book9 !== "" ? (
                                      Number(book9) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book9)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book9)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>
                          <a
                            className="price-price price-back rnr9_status span1details"
                            id="runner9b3span"
                            data-teamname="Winner has Two Pair or worse"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has Two Pair or worse",
                                "3",
                                runner9b3,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner9b3">
                              {runner9b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner9b3_matched"
                            >
                              {runner9b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr9_status span1details"
                            id="runner9b2span"
                            data-teamname="Winner has Two Pair or worse"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has Two Pair or worse",
                                "2",
                                runner9b2,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner9b2">
                              {runner9b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner9b2_matched"
                            >
                              {runner9b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr9_status span1details"
                            id="runner9b1span"
                            data-teamname="Winner has Two Pair or worse"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Winner has Two Pair or worse",
                                "1",
                                runner9b1,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner9b1">
                              {runner9b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner9b1_matched"
                            >
                              {runner9b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr9_status span1details"
                            id="runner9l1span"
                            data-teamname="Winner has Two Pair or worse"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has Two Pair or worse",
                                "1",
                                runner9l1,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner9l1">
                              {runner9l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner9l1_matched"
                            >
                              {runner9l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr9_status span1details"
                            id="runner9l2span"
                            data-teamname="Winner has Two Pair or worse"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has Two Pair or worse",
                                "2",
                                runner9l2,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner9l2">
                              {runner9l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner9l2_matched"
                            >
                              {runner9l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr9_status span1details"
                            id="runner9l3span"
                            data-teamname="Winner has Two Pair or worse"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Winner has Two Pair or worse",
                                "3",
                                runner9l3,
                                2
                              )
                            }
                            market_type="2"
                          >
                            <span className="price-odd" id="runner9l3">
                              {runner9l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner9l3_matched"
                            >
                              {runner9l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr9_status"
                            style={{
                              display:
                                suspend9 != 0 ||
                                rnr9_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr9_status}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="ResultsData"
                  className="tabcontent"
                  style={{ display: showResult ? "contents" : "none" }}
                >
                  {resultData &&
                    resultData.length > 0 &&
                    resultData.map((dataObj, index) => {
                      let win1 = dataObj.rnr1_status;
                      let win2 = dataObj.rnr2_status;
                      let win3 = dataObj.rnr3_status;
                      let win4 = dataObj.rnr4_status;

                      let bgCls1 = win1 == "WINNER" ? "bgwinner" : "bgLoser";
                      let bgCls2 = win2 == "WINNER" ? "bgwinner" : "bgLoser";
                      let bgCls3 = win3 == "WINNER" ? "bgwinner" : "bgLoser";
                      let bgCls4 = win4 == "WINNER" ? "bgwinner" : "bgLoser";

                      let tdCls1 = win1 == "WINNER" ? "TdResultsWin" : "";
                      let tdCls2 = win2 == "WINNER" ? "TdResultsWin" : "";
                      let tdCls3 = win3 == "WINNER" ? "TdResultsWin" : "";
                      let tdCls4 = win4 == "WINNER" ? "TdResultsWin" : "";

                      let cardsArr = dataObj.cards_desc.split(",");
                      let rnr1Arr = dataObj.rnr1_desc.split(",");
                      let rnr2Arr = dataObj.rnr2_desc.split(",");
                      let rnr3Arr = dataObj.rnr3_desc.split(",");
                      let rnr4Arr = dataObj.rnr4_desc.split(",");
                      return (
                        <div
                          class="left-content"
                          style={{ paddingRight: "5px", paddingLeft: "5px" }}
                        >
                          <div
                            class="card"
                            style={{
                              border: "1px solid rgb(204, 204, 204)",
                              borderRadius: "8px",
                              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
                              marginBottom: "5px",
                              background:
                                "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))",
                              color: "white"
                            }}
                          >
                            <div
                              class="card-header card-header-one no-border"
                              style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                                marginBottom: "5px",
                                backgroundColor: "rgba(0, 0, 0, .03)",
                                marginTop: "12px",
                                marginLeft: "16px"
                              }}
                            >
                              {formatResultDate(dataObj.evt_od)} - <b>ID=</b>{" "}
                              {dataObj._id}
                            </div>
                            <div
                              class="card-body"
                              style={{
                                paddingLeft: "5px",
                                paddingRight: "5px"
                              }}
                            >
                              <div
                                class="players-table"
                                style={{ textAlign: "center", width: "100%" }}
                              >
                                <table style={tableStyle}>
                                  <tbody>
                                    <tr
                                      style={rowFlexStyle}
                                      className="players-row"
                                    >
                                      <td
                                        style={tdResultsStyle}
                                        className="TdResults"
                                      >
                                        <div
                                          className="player-cards"
                                          style={playerCardsStyle}
                                        >
                                          <div
                                            className="player-name"
                                            style={playerNameStyle}
                                          >
                                            Community Cards
                                          </div>
                                          <div
                                            className="card-images"
                                            style={cardImagesStyle}
                                          >
                                            {cardsArr &&
                                              cardsArr.length > 0 &&
                                              cardsArr.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);
                                                return (
                                                  <img
                                                    src={cardImage}
                                                    loading="lazy"
                                                    style={cardImgStyle}
                                                  />
                                                );
                                              })}
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr
                                      style={rowFlexStyle}
                                      className="players-row"
                                    >
                                      <td
                                        style={handTdStyle}
                                        className={`TdResults ${tdCls1}`}
                                      >
                                        <div
                                          className="player-cards"
                                          style={playerCardsStyle}
                                        >
                                          <div
                                            className="player-name"
                                            style={playerNameStyle}
                                          >
                                            Hand 1
                                          </div>
                                          <div
                                            className="card-images"
                                            style={handCardImagesStyle}
                                          >
                                            {rnr1Arr &&
                                              rnr1Arr.length > 0 &&
                                              rnr1Arr.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);
                                                return (
                                                  <img
                                                    src={cardImage}
                                                    loading="lazy"
                                                    style={cardHandImgStyle}
                                                  />
                                                );
                                              })}
                                          </div>
                                          <div
                                            className={`player-status ${bgCls1}`}
                                            style={playerStatusStyle}
                                          >
                                            {dataObj.rnr1_status}
                                          </div>
                                        </div>
                                      </td>
                                      <td
                                        style={handTdStyle}
                                        className={`TdResults ${tdCls2}`}
                                      >
                                        <div
                                          className="player-cards"
                                          style={playerCardsStyle}
                                        >
                                          <div
                                            className="player-name"
                                            style={playerNameStyle}
                                          >
                                            Hand 2
                                          </div>
                                          <div
                                            className="card-images"
                                            style={handCardImagesStyle}
                                          >
                                            {rnr2Arr &&
                                              rnr2Arr.length > 0 &&
                                              rnr2Arr.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);
                                                return (
                                                  <img
                                                    src={cardImage}
                                                    loading="lazy"
                                                    style={cardHandImgStyle}
                                                  />
                                                );
                                              })}
                                          </div>
                                          <div
                                            className={`player-status ${bgCls2}`}
                                            style={playerStatusStyle}
                                          >
                                            {dataObj.rnr2_status}
                                          </div>
                                        </div>
                                      </td>

                                      <td
                                        style={handTdStyle}
                                        className={`TdResults ${tdCls3}`}
                                      >
                                        <div
                                          className="player-cards"
                                          style={playerCardsStyle}
                                        >
                                          <div
                                            className="player-name"
                                            style={playerNameStyle}
                                          >
                                            Hand 3
                                          </div>
                                          <div
                                            className="card-images"
                                            style={handCardImagesStyle}
                                          >
                                            {rnr3Arr &&
                                              rnr3Arr.length > 0 &&
                                              rnr3Arr.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);
                                                return (
                                                  <img
                                                    src={cardImage}
                                                    loading="lazy"
                                                    style={cardHandImgStyle}
                                                  />
                                                );
                                              })}
                                          </div>
                                          <div
                                            className={`player-status ${bgCls3}`}
                                            style={playerStatusStyle}
                                          >
                                            {dataObj.rnr3_status}
                                          </div>
                                        </div>
                                      </td>

                                      <td
                                        style={handTdStyle}
                                        className={`TdResults ${tdCls4}`}
                                      >
                                        <div
                                          className="player-cards"
                                          style={playerCardsStyle}
                                        >
                                          <div
                                            className="player-name"
                                            style={playerNameStyle}
                                          >
                                            Hand 4
                                          </div>
                                          <div
                                            className="card-images"
                                            style={handCardImagesStyle}
                                          >
                                            {rnr4Arr &&
                                              rnr4Arr.length > 0 &&
                                              rnr4Arr.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);
                                                return (
                                                  <img
                                                    src={cardImage}
                                                    loading="lazy"
                                                    style={cardHandImgStyle}
                                                  />
                                                );
                                              })}
                                          </div>
                                          <div
                                            className={`player-status ${bgCls4}`}
                                            style={playerStatusStyle}
                                          >
                                            {dataObj.rnr4_status}
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
              <div
                className="col-lg-4"
                style={{ paddingLeft: "1px", paddingRight: "1px" }}
              >
                <div className="right-content">
                  <div>
                    {showBetSlipPopup && (
                      <TPPopUpBetSlip
                        closeBetSlipParent={closeBetSlipMobile}
                        betObj={placeBetObject}
                        placeBetParent={placeBet}
                        betButtonShow={betButtonShow}
                        betErrorMessageObj={betErrorMessageObj}
                        betButtonShowLoaderShow={betButtonShowLoaderShow}
                        profileData={profileData}
                        loading={loading}
                        stakeList={stakeList}
                      />
                    )}
                    <BetfairCasinoBetslipWeb
                      showBetSlip={showBetSlip}
                      placeBetObject={placeBetObject}
                      closeBetSlipParent={closeBetSlip}
                      placeBetParent={placeBet}
                      loading={loading}
                      betErrorMessageObj={betErrorMessageObj}
                      stakeList={stakeList}
                    ></BetfairCasinoBetslipWeb>
                    <div className="bets">
                      <strong style={{ color: "white" }}>
                        Matched Bets ({totalBets})
                      </strong>
                      <div className="betting-table">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Runner</th>
                              <th>Price</th>
                              <th>Size</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody id="refreshhistory">
                            {betList.length > 0 ? (
                              betList.map((item, index) => (
                                <tr
                                  style={{
                                    background:
                                      item.type == "b" ? "#e9f6fc" : "#fce3e4",
                                    color: "#000",
                                    fontSize: "15px",
                                    textAlign: "center"
                                  }}
                                >
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "15px",
                                      display: "table-cell",
                                      padding: "5px"
                                    }}
                                  >
                                    {item.rnr !== "" ? (
                                      item.rnr == "runner1b1" ||
                                      item.rnr == "runner1b2" ||
                                      item.rnr == "runner1b3" ||
                                      item.rnr == "runner1l1" ||
                                      item.rnr == "runner1l2" ||
                                      item.rnr == "runner1l3" ? (
                                        <span>Hand 1</span>
                                      ) : item.rnr == "runner2b1" ||
                                        item.rnr == "runner2b2" ||
                                        item.rnr == "runner2b3" ||
                                        item.rnr == "runner2l1" ||
                                        item.rnr == "runner2l2" ||
                                        item.rnr == "runner2l3" ? (
                                        <span>Hand 2</span>
                                      ) : item.rnr == "runner3b1" ||
                                        item.rnr == "runner3b2" ||
                                        item.rnr == "runner3b3" ||
                                        item.rnr == "runner3l1" ||
                                        item.rnr == "runner3l2" ||
                                        item.rnr == "runner3l3" ? (
                                        <span>Hand 3</span>
                                      ) : item.rnr == "runner4b1" ||
                                        item.rnr == "runner4b2" ||
                                        item.rnr == "runner4b3" ||
                                        item.rnr == "runner4l1" ||
                                        item.rnr == "runner4l2" ||
                                        item.rnr == "runner4l3" ? (
                                        <span>Hand 4</span>
                                      ) : item.rnr == "runner5b1" ||
                                        item.rnr == "runner5b2" ||
                                        item.rnr == "runner5b3" ||
                                        item.rnr == "runner5l1" ||
                                        item.rnr == "runner5l2" ||
                                        item.rnr == "runner5l3" ? (
                                        <span>Winner has FH or better</span>
                                      ) : item.rnr == "runner6b1" ||
                                        item.rnr == "runner6b2" ||
                                        item.rnr == "runner6b3" ||
                                        item.rnr == "runner6l1" ||
                                        item.rnr == "runner6l2" ||
                                        item.rnr == "runner6l3" ? (
                                        <span>Winner has Flush</span>
                                      ) : item.rnr == "runner7b1" ||
                                        item.rnr == "runner7b2" ||
                                        item.rnr == "runner7b3" ||
                                        item.rnr == "runner7l1" ||
                                        item.rnr == "runner7l2" ||
                                        item.rnr == "runner7l3" ? (
                                        <span>Winner has Straight</span>
                                      ) : item.rnr == "runner8b1" ||
                                        item.rnr == "runner8b2" ||
                                        item.rnr == "runner8b3" ||
                                        item.rnr == "runner8l1" ||
                                        item.rnr == "runner8l2" ||
                                        item.rnr == "runner8l3" ? (
                                        <span>Winner has Three of a Kind</span>
                                      ) : item.rnr == "runner9b1" ||
                                        item.rnr == "runner9b2" ||
                                        item.rnr == "runner9b3" ||
                                        item.rnr == "runner9l1" ||
                                        item.rnr == "runner9l2" ||
                                        item.rnr == "runner9l3" ? (
                                        <span>
                                          Winner has Two Pair or worse
                                        </span>
                                      ) : (
                                        <span></span> // For any other value
                                      )
                                    ) : (
                                      <span></span>
                                    )}
                                    - {item.cat_mid}
                                  </td>
                                  <td
                                    style={{
                                      display: "table-cell",
                                      textAlign: "left",
                                      padding: "5px"
                                    }}
                                  >
                                    {item.rate}
                                  </td>
                                  <td
                                    style={{
                                      display: "table-cell",
                                      textAlign: "left",
                                      padding: "5px"
                                    }}
                                  >
                                    {item.amnt}
                                  </td>
                                  <td></td>
                                </tr>
                              ))
                            ) : (
                              <tr></tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </ClientLayout>
  );
};

export default BetfairOmaha;


